import React from 'react';
import { Link } from 'react-router-dom';
import { footerData } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="bg-[#082900]">
      {/* CTA Section */}
      <div className="max-w-[1121px] mx-auto px-6 lg:px-10 pt-24 lg:pt-32 pb-16 lg:pb-20">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          <h2 className="text-[#EEF2E1] text-[36px] lg:text-[64px] font-light leading-[1.05] tracking-[-0.02em]" style={{ fontStyle: 'italic' }}>
            Interview everyone.<br />Hire the best.
          </h2>
          <Link
            to="/demo"
            className="flex-shrink-0 px-8 py-3.5 border border-[#EEF2E1]/30 text-[#EEF2E1] text-[14px] font-normal rounded-full hover:bg-[#EEF2E1]/10 transition-colors duration-300"
          >
            Request a demo
          </Link>
        </div>
      </div>

      {/* Divider */}
      <div className="max-w-[1121px] mx-auto px-6 lg:px-10">
        <div className="border-t border-[#EEF2E1]/15" />
      </div>

      {/* Footer Links */}
      <div className="max-w-[1121px] mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-0">
          {/* Logo */}
          <div className="lg:w-[280px] flex-shrink-0">
            {/* Duty AI Logomark - matching alex.com style */}
            <svg width="56" height="68" viewBox="0 0 26 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-12 lg:mb-0">
              <path d="M13 0C13 0 0 15.5 0 22.5C0 27.75 5.82 32 13 32C20.18 32 26 27.75 26 22.5C26 15.5 13 0 13 0Z" fill="#EEF2E1"/>
              <path d="M13 8C13 8 4.5 19 4.5 23.5C4.5 27.09 8.3 30 13 30C17.7 30 21.5 27.09 21.5 23.5C21.5 19 13 8 13 8Z" fill="#082900" opacity="0.3"/>
              <path d="M13 15C13 15 8 22.5 8 25C8 27.76 10.24 29 13 29C15.76 29 18 27.76 18 25C18 22.5 13 15 13 15Z" fill="#082900" opacity="0.5"/>
            </svg>
          </div>

          {/* Link Columns */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12 flex-1">
            {footerData.columns.map((col, i) => (
              <div key={i}>
                <h4 className="text-[#EEF2E1]/40 text-[14px] font-normal mb-5">
                  {col.title}
                </h4>
                <ul className="space-y-3.5">
                  {col.links.map((link, j) => (
                    <li key={j}>
                      <Link
                        to={link.href}
                        className="text-[#EEF2E1]/80 text-[14px] font-normal hover:text-[#EEF2E1] transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-16 lg:mt-20">
          <p className="text-[#EEF2E1]/30 text-[13px] font-normal leading-relaxed whitespace-pre-line">
            {footerData.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
